import api from '@/services/api'
import { useAuth } from '@/hooks/useAuth'

import styles from '../student.admin.module.scss'

import { ViewType } from '../student.admin'
import { AlunoRepository } from '@/pages/admin/repositories/aluno.repository'
import { IDocument } from './documents'

interface IProps {
  setView: React.Dispatch<React.SetStateAction<ViewType>>
  documents: IDocument[]
  listDocuments: () => void
  setLoading: React.Dispatch<React.SetStateAction<Boolean>>
}

export const AddDocument = ({
  setView,
  documents,
  listDocuments,
  setLoading,
}: IProps) => {
  const { token } = useAuth()

  async function deleteDocument(document_id: string) {
    setLoading(true)
    await AlunoRepository.GetInstance().adminDeleteDocumento(token, document_id)
    listDocuments()
    setLoading(false)
  }

  return (
    <div className={styles.documents}>
      {documents?.map((doc) => {
        return (
          <p>
            <div>
              {doc?.tipo?.replaceAll('%2', ' ')} ---
              <a
                target="blank"
                href={`${api.getUri()}/uploads/documentos/${doc?.arquivo}`}
                rel="noreferrer"
              >
                {doc?.arquivo}
              </a>
            </div>
            <button onClick={() => deleteDocument(doc.id.toString())}>
              APAGAR
            </button>
          </p>
        )
      })}

      <button onClick={() => setView('ADD DOCUMENT')}>
        Adicionar Documento
      </button>
    </div>
  )
}
